<template>
  <Layout
    header-class="header-left-align"
    :footer-style="2"
    buy-button-class="btn-default btn-small"
    :show-top-header="false"
    :show-copyright="false"
    :show-theme-switcher-button="false"
    :header-style="2"
    :no-bg="true"
  >
    <div class="slider-area">
      <div class="container">
        <div
          style="
            border-radius: 18px;
            background: #0e1118;
            margin-top: 60px;
            padding: 0px 50px;
            position: relative;
            height: 339px;
            margin-bottom: 91px;
          "
        >
          <img src="../assets/images/bg/home-bg.png" style="position: absolute; right: 0px;top: 0px;"/>
          <div
            style="
              color: white;
              font-size: 40px;
              font-weight: 500;
              margin-bottom: 33px;
            "
          >
            Liquidity for NFTs
          </div>
          <div style="color: white; font-size: 20px; margin-bottom: 46px">
            Use NFTs as collateral to borrow liquidity or deposit to earn yields
            instantly!
          </div>
          <div
            style="
              color: rgba(255, 255, 255, 0.4);
              font-weight: 500;
              font-size: 20px;
              margin-bottom: 17px;
            "
          >
            TVL
          </div>
          <div style="display: flex; align-items: center">
            <div class="btn-money">$16,233.43</div>
            <div class="btn-join">
              <img
                src="../assets/images/icons/join.svg"
                style="width: 37.5px; height: 28.57px"
              />
              Join us
            </div>
          </div>
        </div>
        <div style="margin-bottom: 220px;">
          <Counter
            :counter-style="7"
            text-align="text-start"
            :counter-data="counterFiveData"
            column="col-lg-4 col-md-6 col-sm-6 col-12"
          />
          <Counter
            :counter-style="7"
            text-align="text-start"
            :counter-data="counterFiveDataTwo"
            column="col-lg-4 col-md-6 col-sm-6 col-12"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Icon from '@/components/icon/Icon'
import Counter from '@/components/elements/counterUp/Counter'
import ServiceTwo from '@/components/elements/service/ServiceTwo'
import Web3 from 'web3'

export default {
  name: 'Home',
  components: {
    Icon,
    Layout,
    Counter,
    ServiceTwo,
  },
  data() {
    return {
      iconOne: require('../assets/images/counter/icon-one.svg'),
      counterFiveData: [
        {
          number: 0,
          title: 'Available',
          decimals: 2,
          icon: require('../assets/images/counter/icon-two.svg'),
        },
        {
          number: 0,
          title: 'Borrowed',
          suffix: '%',
          decimals: 2,
          icon: require('../assets/images/counter/icon-two.svg'),
        },
        {
          number: 0,
          title: 'Collateralls',
          decimals: 2,
          icon: require('../assets/images/counter/icon-two.svg'),
        },
      ],
      counterFiveDataTwo: [
        {
          number: 0,
          title: 'Deposit APR',
          suffix: '%',
          decimals: 2,
          icon: require('../assets/images/counter/icon-three.svg'),
        },
        {
          number: 0,
          title: 'Borrow APR',
          suffix: '%',
          decimals: 2,
          icon: require('../assets/images/counter/icon-three.svg'),
        },
        {
          number: 0,
          title: 'Utilization rate',
          suffix: '%',
          decimals: 2,
          icon: require('../assets/images/counter/icon-three.svg'),
        },
      ],
      cardXWidth: 0,
      containerHeight: '0px',
      progress: 0,
      innerWidth: 0,
      wrapperWidth: 0,
      maxProgress: 0,
      web3: null,
      account: '',
    }
  },
  mounted() {
    // this.cardXWidth = this.$refs.cardX.getBoundingClientRect().width;
    // this.containerHeight = `${428 + 2004 - this.cardXWidth}px`
    // this.innerWidth = window.innerWidth
    // this.wrapperWidth = this.$refs.cardXContent.offsetWidth
    // this.maxProgress = (428 + 2004 - this.cardXWidth) / 2004 * 100
    // this.onScroll()
    // window.addEventListener('scroll', this.onScroll)
  },
  beforeUnmount() {
    // window.removeEventListener('scroll')
  },
  methods: {
    async selectMetamask() {
      await this.initWeb3()
      await this.getAccount()
    },
    async initWeb3() {
      if (window.ethereum) {
        this.web3 = new Web3(window.ethereum)
        try {
          await window.ethereum.enable()
        } catch (error) {
          console.log(error)
        }
      } else if (window.web3) {
        this.web3 = new Web3(window.web3.currentProvider)
      }
    },
    async getAccount() {
      if (this.web3) {
        const accounts = await this.web3.eth.getAccounts()
        if (Array.isArray(accounts) && accounts.length > 0) {
          this.account = accounts[0]
          this.$account.metamask = accounts[0]
        }
      } else {
        this.$message.info('请安装Metamask！')
      }
    },
    onScroll() {
      const { scrollTop } = document.documentElement
      const containerTop = this.$refs.cardX.offsetTop + 428 - window.innerHeight
      const containerHeightNumber = 428 + 2004 - this.cardXWidth
      const newProgress =
        ((scrollTop - containerTop) * 100) /
        (containerHeightNumber - window.innerHeight + 428)
      this.progress = newProgress
    },
  },
}
</script>

<style scoped lang="scss">
.borrow-area {
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.03);
  box-shadow: -2px 0px 20px 12px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(49px);
  padding: 53px 56px;
  margin-top: 60px;
  margin-bottom: 60px;
}

.depost-btn {
  width: 337.07px;
  height: 50px;
  border-radius: 16px;
  background: #1c2333;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Outfit;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.depost-btn-active {
  color: #a1fe04;
}

.action-btn {
  width: 188px;
  height: 64px;
  border-radius: 18px;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
}

.btn-money {
  padding: 0px 45px;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  color: black;
  border-radius: 18px;
  background: #a1fe04;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 40px;
  height: 83.5px;
}

.btn-join {
  padding: 0px 45px;
  height: 83.5px;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  color: white;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(161, 254, 4, 0.26);
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
